import React from 'react'
import { Alert } from 'reactstrap'

export default function ErrorMessage({children}) {
  return (
    <Alert color="warning">{children}</Alert>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/NewManageUsers/ManagePane/InfoCard/ActionBlockComponents/ErrorMessage.js